import RootStore  from 'mobx-stores/root-store'
import { TriggerSearchFunc, ProductsTableBase } from 'mobx-stores/utils'

export class StoreProductsTableStore extends ProductsTableBase {
  private rootStore: any
  
  constructor (rootStore: any) {
    console.log('rootStore', rootStore);
    super()
    this.rootStore = rootStore
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    if (!this.storeId) return
    const data = await this.rootStore.generalStore.api.storeApi.getAllProductsFiltered(
      this.storeId,
      this.productFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )
    this.handleSearchResult(data)
  }

  // COMPUTED
  private get storeId (): number {
    return this.rootStore.userStore.effectiveStoreId
  }
}
